import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useCreateLotSizingAction } from './hooks/use-create-lot-sizing-action';

export function PurchasePlanningCreateLotSizing() {
  const { t } = useTranslation('purchasePlanning');
  const { handleSubmit, onSubmit, isPending, canCreate, validationErrorKey } =
    useCreateLotSizingAction();

  return (
    <div className='absolute top-0 right-0 z-10'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span>
              <Button disabled={isPending || !canCreate} type='submit'>
                {t('CreateLotSizing')}
              </Button>
            </span>
          </TooltipTrigger>
          {!canCreate && validationErrorKey && (
            <TooltipContent>{t(validationErrorKey)}</TooltipContent>
          )}
        </Tooltip>
      </form>
    </div>
  );
}
